import * as React from "react";

const Loader = () => <h3>Loading...</h3>;

export default Loader;
